








































import { Component, Prop, Watch, Vue, Provide } from 'vue-property-decorator';
import { get } from 'lodash';

@Component({
  components: {
    ElementBlocOldInterpretation: () => import('@/components/elements/ElementBlocOldInterpretation.vue'),
  },
})
export default class ElementBlocGeneralInterpretation extends Vue {
  @Prop({ required: true, default: null }) acquisition!: any;
  @Provide() generalParameters: string | null = null;
  @Provide() angleParameters: string | null = null;

  get interpretations() {
    return get(this.acquisition.computed_data, 'interpretations', false);
  }
  get recommendations() {
    return (
      get(this.acquisition.computed_data, 'recommendations', false) &&
      get(this.acquisition.computed_data, 'recommendations.podosmart', false)
    );
  }
  get isOldRecommendations() {
    return this.recommendations && get(this.recommendations[0], 'id', false);
  }
  get isLastRecommendations() {
    return this.recommendations && get(this.recommendations, 'clearance', false);
  }

  @Watch('acquisition', { deep: true, immediate: true })
  onAcquisitionChange() {
    if (this.isLastRecommendations) {
      this.getNewInterpretations();
    } else {
      this.generalParameters = null;
      this.angleParameters = null;
    }
  }

  getNewInterpretations() {
    this.generalParameters = this.getNewInterpretationsText(this.recommendations.general_parameters);
    if (this.interpretations) this.angleParameters = this.getNewInterpretationsText(this.interpretations.roll_out);
  }
  getNewInterpretationsText(parameter: any) {
    const hasLeft = get(parameter, 'left', false);
    const hasRight = get(parameter, 'right', false);
    const hasSymmetry = get(parameter, 'symmetry', false);

    let text = '';
    let symmetry = '';
    if (hasLeft && hasRight && hasLeft === hasRight) {
      text = `${this.getTranslate(this.checkRollOutText(parameter.left), 'symmetry')}`;
    }
    if (hasLeft && hasRight && hasLeft !== hasRight) {
      text = `${this.getTranslate(this.checkRollOutText(parameter.left), 'left')} - ${this.getTranslate(
        parameter.right,
        'right',
      )}`;
    }
    if (hasLeft && !hasRight) {
      text = `${this.getTranslate(this.checkRollOutText(parameter.left), 'left')}`;
    }
    if (!hasLeft && hasRight) {
      text = `${this.getTranslate(this.checkRollOutText(parameter.right), 'right')}`;
    }
    if (!hasLeft && !hasRight && !hasSymmetry) {
      text = '';
    }
    if (hasSymmetry) {
      symmetry = `${this.getTranslate(this.checkRollOutText(parameter.symmetry), 'globals')}`;
    }
    return `${hasSymmetry ? symmetry + '\n' + text : text}`;
  }
  getTranslate(code: string, type: string) {
    return this.$t(`interpretations.${type}.${code}`);
  }
  // Check because of biomechanical forgot
  checkRollOutText(text: string) {
    if (text === 'ROLL_OUT_4' || text === 'ROLL_OUT_5') {
      return text.slice(0, 9) + 'TEXT_' + text.slice(9, 10);
    } else {
      return text;
    }
  }
  breakLine(val: string) {
    return val.replace(/(\r\n|\n)/g, '<br/>');
  }
}
